import type { ZipOption } from '../types';
import { Icon } from '@/new/components/icon';

interface Props {
  value: ZipOption;
  onChange: (value: ZipOption) => void;
}

const OPTIONS: Array<{ id: ZipOption; icon: string; label: string; description: string }> = [
  {
    id: 'original',
    icon: 'lucide--file',
    label: 'Original files',
    description: 'As uploaded (.docx, .pdf, .eml…)',
  },
  {
    id: 'asPDF',
    icon: 'lucide--file-text',
    label: 'Processed PDFs',
    description: 'Rendered PDF view of each doc',
  },
];

export const ZipContentField = ({ value, onChange }: Props) => (
  <div className="flex flex-row flex-wrap gap-3">
    {OPTIONS.map((opt) => {
      const selected = value === opt.id;
      return (
        <button
          key={opt.id}
          type="button"
          onClick={() => onChange(opt.id)}
          className={`flex flex-1 cursor-pointer flex-col items-center justify-start rounded-lg border p-4 transition-all duration-200 ${
            selected
              ? 'border-blue-300 bg-blue-50/50 shadow-sm shadow-blue-100/50'
              : 'border-gray-200 bg-gray-50/50 hover:border-blue-300 hover:shadow-md hover:shadow-blue-100/50'
          }`}
        >
          <div
            className={`mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-blue-50 to-blue-100/50 text-lg ${
              selected ? 'text-blue-600' : 'text-blue-500'
            }`}
          >
            <Icon className={opt.icon} />
          </div>
          <span className="mb-0.5 text-sm font-medium text-gray-700">{opt.label}</span>
          <span className="text-center text-xs text-gray-400">{opt.description}</span>
        </button>
      );
    })}
  </div>
);
